import script from "./ShareModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShareModal.vue?vue&type=script&lang=ts&setup=true"

import "./ShareModal.vue?vue&type=style&index=0&id=83ac9098&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83ac9098"]])

export default __exports__